import React from 'react';

interface BadgeProps {
  className?: string;
}

const AppStoreBadge: React.FC<BadgeProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 160 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background */}
      <rect width="160" height="50" rx="10" fill="white" />
      
      <g transform="translate(22, 11)">
        {/* Refined Apple Logo */}
        <path
          fill="black"
          d="M22.3,16.7c-1.2,0-2.3,0.7-3.6,0.7c-1.3,0-2.6-0.7-3.7-0.7c-2.6,0-5.3,2-5.3,5.8c0,4.4,3.9,10.7,7.8,10.7
          c1,0,1.5-0.7,2.9-0.7c1.4,0,1.8,0.7,2.9,0.7c2.6,0,4.4-2.4,6-4.7c1.2-1.7,1.7-3.4,1.7-3.5c0-0.1-3.3-1.3-3.3-5
          c0-3.1,2.5-4.6,2.6-4.7C28.9,17.9,26.1,16.7,22.3,16.7z M21.7,14.5c1.1-1.4,1.9-3.3,1.7-5c-1.6,0.1-3.6,1.1-4.7,2.4
          c-1,1.2-1.9,3.1-1.7,4.8C18.7,16.9,20.6,15.8,21.7,14.5z"
          transform="translate(-9.7, -9.5) scale(1.0)" 
        />
        
        {/* Text Group */}
        <g transform="translate(28, 0)">
          <text x="0" y="8" fill="black" fontSize="9" fontFamily="sans-serif">Download on the</text>
          <text x="0" y="24" fill="black" fontSize="19" fontFamily="sans-serif" fontWeight="bold">App Store</text>
        </g>
      </g>
    </svg>
  );
};

export default AppStoreBadge;
